import { render, staticRenderFns } from "./PhotoMediaReviewView.vue?vue&type=template&id=941785ae&"
import script from "./PhotoMediaReviewView.vue?vue&type=script&lang=js&"
export * from "./PhotoMediaReviewView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports